import { useUserContext } from '@/shared/contexts/userContext'
import { cn } from '@/shared/lib/utils'
import React, { ComponentProps } from 'react'
import { LoggedOutUser } from './LoggedOutUser'
import { UserMenu } from './UserMenu'

type UserAuthProps = ComponentProps<'div'>

export const UserAuth: React.FC<UserAuthProps> = ({ className }) => {
  const { user, isLoading, error } = useUserContext()

  const isUserLoggedIn = !!user && !error

  if (isLoading) {
    return (
      <div
        className={cn('flex h-10 w-10 items-center justify-center', className)}
      >
        <div className="h-6 w-6 animate-spin rounded-full border-2 border-t-gray-600"></div>
      </div>
    )
  }

  return isUserLoggedIn ? (
    <UserMenu user={user} className={className} />
  ) : (
    <LoggedOutUser className={className} />
  )
}
